var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"foot"},[_c('p',{staticClass:"foottext"},[_vm._v("Copyright © "+_vm._s(_vm.year)+" by The CCDAO. All Rights Reserved.")]),_c('img',{attrs:{"src":require("../assets/foottag.svg")}})])}
var staticRenderFns = []

export { render, staticRenderFns }